import { Component, OnInit } from '@angular/core';
import { PostsService } from '../posts.service';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash'; 

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {

  public team;

  constructor(private posts:PostsService, private titleService:Title) { }

  ngOnInit() {
    this.titleService.setTitle("Team -- Bender Hardware");

    this.posts.getTeam().then((posts)=>{
      this.team = posts.results;
    }).catch(console.error);
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/team/team.component.ts